import Reflux from 'reflux'

export default Reflux.createActions(['lookupReturn','lookupasteriskRefresh','renderCmp','lookupRefresh','lookupHostKeydown','lookupReturnMutiField','lookupReturnMutiEditor','popDropDownClose','lookupAutoQuery','lookupUnmount']);


// WEBPACK FOOTER //
// ./src/actions/LookupActions.js